import script from "./ServicesAndActivities.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesAndActivities.vue?vue&type=script&setup=true&lang=js"

import "./ServicesAndActivities.vue?vue&type=style&index=0&id=56fff28c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fff28c"]])

export default __exports__